import React from 'react';
import PropTypes from 'prop-types';

import { StyledImage } from './styles';

const Image = ({
  src,
  srcSet,
  sizes,
  alt,
  width,
  height,
  loading,
  borderRadius
}) => {
  const fallbackImg =
    'https://images.fastcompany.net/image/upload/v1485990651/fcweb/fastcompanyimagedefault.jpg';

  return (
    <StyledImage
      src={src || fallbackImg}
      srcSet={srcSet}
      sizes={sizes}
      alt={alt}
      width={width}
      height={height}
      borderRadius={borderRadius}
      loading={loading}
    />
  );
};
Image.propTypes = {
  src: PropTypes.string.isRequired,
  srcSet: PropTypes.string,
  sizes: PropTypes.string,
  alt: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  borderRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  loading: PropTypes.oneOf(['lazy', 'eager'])
};

Image.defaultProps = {
  srcSet: undefined,
  sizes: undefined,
  width: undefined,
  height: undefined,
  borderRadius: '0px',
  loading: 'eager',
  alt: ''
};

export default Image;
